import { render, staticRenderFns } from "./MovementRouteLessonEdit.vue?vue&type=template&id=c5544b5c"
import script from "./MovementRouteLessonEdit.vue?vue&type=script&lang=js"
export * from "./MovementRouteLessonEdit.vue?vue&type=script&lang=js"
import style0 from "./MovementRouteLessonEdit.vue?vue&type=style&index=0&id=c5544b5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports